import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraButton } from '../ensigns/button';
/** Consistent cancel/confirm action bar for modals and drawers. */ export const SpecraOverlayFooter = /*#__PURE__*/ React.forwardRef(({ cancelLabel = 'Cancel', cancelProps, className, confirmDisabled, confirmLabel = 'Save', confirmProps, leading, loading, loadingLabel = 'Working…', onCancel, onConfirm, tray, ...props }, ref)=>{
    const actionRow = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "min-w-0 flex-1 text-[length:var(--fs-ui-caption)] text-muted-foreground",
                children: leading
            }),
            onCancel || cancelProps ? /*#__PURE__*/ _jsx(SpecraButton, {
                ...cancelProps,
                onClick: (event)=>{
                    cancelProps?.onClick?.(event);
                    if (!event.defaultPrevented) onCancel?.();
                },
                variant: cancelProps?.variant ?? 'secondary',
                children: cancelLabel
            }) : null,
            onConfirm || confirmProps ? /*#__PURE__*/ _jsx(SpecraButton, {
                ...confirmProps,
                disabled: confirmDisabled || loading || confirmProps?.disabled,
                onClick: (event)=>{
                    confirmProps?.onClick?.(event);
                    if (!event.defaultPrevented) onConfirm?.();
                },
                children: loading ? loadingLabel : confirmLabel
            }) : null
        ]
    });
    if (tray) {
        return /*#__PURE__*/ _jsxs("footer", {
            className: cn('flex flex-col gap-3 border-t border-border bg-muted/30 px-4 py-3 sm:px-5', className),
            "data-tray": "",
            ref: ref,
            ...props,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-3",
                    "data-slot": "overlay-footer-tray",
                    children: tray
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col-reverse items-stretch gap-2 sm:flex-row sm:items-center",
                    children: actionRow
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("footer", {
        className: cn('flex flex-col-reverse items-stretch gap-2 border-t border-border px-4 py-3 sm:flex-row sm:items-center sm:px-5', className),
        ref: ref,
        ...props,
        children: actionRow
    });
});
SpecraOverlayFooter.displayName = 'SpecraOverlayFooter';
